export const ErrorFallback = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem",
      fontFamily: "system-ui, sans-serif",
      textAlign: "center",
    }}
  >
    <h1 style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>
      Algo salió mal
    </h1>
    <p style={{ color: "#555", marginBottom: "1.5rem" }}>
      Estamos trabajando para resolverlo. Por favor, recargá la página.
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      style={{
        padding: "0.5rem 1rem",
        borderRadius: "0.375rem",
        border: "1px solid #ccc",
        background: "#fff",
        cursor: "pointer",
      }}
    >
      Recargar
    </button>
  </div>
);
